// extracted by mini-css-extract-plugin
module.exports = {"wrapRegister":"style_wrapRegister__1EohD","inputForm":"style_inputForm__3eIJb"};